/* Data models metadata service */

export class Models {
  constructor(loadWithCache) {
    this.loadWithCache = loadWithCache;
  }

  load() {
    return this.loadWithCache('/analytics/model/', {});
  }
}



// WEBPACK FOOTER //
// ./src/core/model-resource.service.js